import { forwardRef, type Ref, type SVGProps } from "react";
const IconDogSmallOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.838 20.505c0 .944-.78 1.71-1.741 1.71s-1.742-.766-1.742-1.71c0-.943.78-1.709 1.742-1.709.961 0 1.74.766 1.74 1.71"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.207 20.717 5.75 3.218a.666.666 0 0 0 .971-.423l.89-3.65c1.223-5.025-2.582-9.868-7.754-9.868s-8.976 4.843-7.752 9.868l.898 3.687a.672.672 0 0 0 .972.432zM16.064 8.22c-6.32 0-10.972 5.92-9.476 12.062l.899 3.687a2.445 2.445 0 0 0 3.54 1.571l5.166-2.798 4.897 2.74a2.44 2.44 0 0 0 3.561-1.55l.89-3.65C27.036 14.14 22.385 8.22 16.064 8.22"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.502 23.804c1.425.972 3.07 1.522 4.82 1.522s3.396-.55 4.82-1.522l1 1.464c-1.697 1.159-3.687 1.831-5.82 1.831-2.132 0-4.123-.672-5.82-1.83z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.098 18.216a1.16 1.16 0 1 1-2.321 0 1.16 1.16 0 0 1 2.321 0m10.706 0a1.16 1.16 0 1 1-2.322 0 1.16 1.16 0 0 1 2.322 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.034 7.432C1.716 5.589 3.717 4.23 5.313 5.205l6.99 4.27-.925 1.513-6.99-4.27a.403.403 0 0 0-.607.413l1.37 7.953a.4.4 0 0 0 .264.312l1.982.693-.586 1.674-1.982-.693a2.18 2.18 0 0 1-1.426-1.685zm27.933 0c.317-1.843-1.684-3.202-3.28-2.227l-6.99 4.27.925 1.513 6.99-4.27a.403.403 0 0 1 .607.413l-1.37 7.953a.4.4 0 0 1-.264.312l-1.982.693.586 1.674 1.982-.693a2.18 2.18 0 0 0 1.426-1.685z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconDogSmallOutlineSVG);
ForwardRef.displayName = "IconDogSmallOutline";
export { ForwardRef as IconDogSmallOutline };
